<template>
  <div>
    <v-card>
      <slot name="title">
        <div class="d-flex justify-space-between py-4 px-2">
          <h3>User Allocation</h3>
          <div>
            <v-btn
              color="danger"
              v-if="userAllocation"
              @click="deleteAllocation(userAllocation.id)"
            >
              Delete Allocation
            </v-btn>
            <v-btn color="primary" @click="toggleForm">
              {{ userAllocation !== null ? "Update" : "Add" }} Allocation
            </v-btn>
          </div>
        </div>
      </slot>
      <v-card-text>
        <v-row v-if="userAllocation" class="d-flex justify-space-between">
          <v-col cols="12" class="d-flex justify-space-between">
            <key-value title="Purpose" :value="userAllocation.purpose" />
            <key-value title="Amount">
              <span>€{{ userAllocation.amount | currency }}</span>
            </key-value>
            <key-value title="Start Date" :value="userAllocation.start_date" type="none" />
            <key-value title="End Date" :value="userAllocation.end_date" type="none" />
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="12" aria-rowspan="12" class="d-flex justify-space-between">
            <h4 class="text-center">No allocation found</h4>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Optionally include the form for adding/updating business relations -->
    <v-dialog v-model="formVisible" @click:outside="closeDialog" width="600px">
      <v-card>
        <v-card-title class="primary white--text d-flex justify-space-between">
          <span> {{ userAllocation ? "Update" : "Add" }} User Allocation</span>
          <v-btn text icon dark @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-container>
          <custom-form
            ref="form"
            :fields="userAllocationForm"
            method="post"
            :action="url"
            @submitted="submittedSuccessfully"
          >
            <v-row no-gutters>
              <v-col cols="12" class="px-1">
                <custom-input name="amount" label="Amount(Euro)" />
                <custom-input name="purpose" label="Purpose" />
                <custom-input name="start_date" label="Start Date(yyyy-mm-dd)" />
                <custom-input name="end_date" label="End Date(yyyy-mm-dd)" />
              </v-col>
              <v-col cols="12" class="px-1">
                <div class="flex-grow-1"></div>
                <v-btn color="primary" type="submit" rounded>
                  {{ userAllocation ? "Update" : "Add" }} Allocation
                </v-btn>
              </v-col>
            </v-row>
          </custom-form>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import instance from "@/services/http";
export default {
  props: {
    userAllocation: { type: Object },
    userId: { type: String },
  },
  data() {
    return {
      userAllocationForm: {
        amount: 0,
        purpose: "",
        start_date: null,
        end_date: null,
        is_individual: true,
      },
      editMode: false,
      formVisible: false,
      url: `/api/v1/allocations/${this.userId}`,
    };
  },
  mounted() {
    if (this.userAllocation) {
      this.userAllocationForm = {
        amount: this.userAllocation.amount,
        purpose: this.userAllocation.purpose,
        start_date: this.userAllocation.start_date,
        end_date: this.userAllocation.end_date,
        is_individual: true,
      };
    }
  },
  methods: {
    async deleteAllocation(id) {
      await Notify.confirm(`Are you sure you want to delete this user allocation?`).then(
        async () => {
          try {
            const response = await this.$http.delete(`/api/v1/allocations/${id}`);
            if (response.status === 204) {
              Notify.success(response.data.message || "Deleted successfully.");
              window.location.reload();
            } else {
              Notify.error(`Unexpected status: ${response.status}`);
            }
          } catch (error) {
            Notify.error(error.message || "An error occurred.");
          }
        },
      );
    },
    async submittedSuccessfully() {
      await window.location.reload();
    },
    createOrUpdateUserAllocation() {
      instance
        .post(this.url, this.userAllocationForm)
        .then(() => {
          this.tableKey++;
          this.resetForm();
        })
        .catch((error) => {
          console.error("Error creating user allocation:", error);
        });
    },

    updateAllocation() {
      instance
        .put(`${this.url}/${this.userAllocationForm.id}`, this.userAllocationForm)
        .then(() => {
          this.tableKey++;
          this.resetForm();
        })
        .catch((error) => {
          console.error("Error updating business relation:", error);
        });
    },

    submitForm() {
      if (this.editMode) {
        this.updateAllocation();
      } else {
        this.createOrUpdateUserAllocation();
      }
    },

    editBusinessRelation(relation) {
      this.userAllocationForm = { ...relation };
      this.editMode = true;
      this.formVisible = true;
    },

    deleteBusinessRelation(id) {
      if (confirm("Are you sure you want to delete this business relation?")) {
        instance
          .delete(`${this.url}/${id}`)
          .then(() => {
            this.tableKey++;
          })
          .catch((error) => {
            console.error("Error deleting business relation:", error);
          });
      }
    },

    resetForm() {
      this.userAllocationForm = {
        id: null,
        owner: "",
        author: "",
        text: "",
      };
      this.editMode = false;
      this.formVisible = false;
    },

    toggleForm() {
      this.formVisible = !this.formVisible;
      if (!this.formVisible) {
        this.resetForm();
      }
    },

    showDetails(item) {
      console.log(item);
    },

    closeDialog() {
      this.formVisible = false;
    },
  },
};
</script>

<style scoped>
.business-relation-card {
  margin: 20px 0;
}
</style>
